import { deviceInfo as device } from '$lib/services/legacy/device';
import { COOKIES } from '$lib/services/legacy/standaloneRegistration/constants';

export const isIOS = (): boolean =>
    /ipad|iphone|ipod/.test(window?.navigator?.userAgent?.toLowerCase());

export const isIOSNative = (): boolean => (window?.native && isIOS()) || false;

export const isAndroid = (): boolean =>
    window?.navigator?.userAgent.toLowerCase().includes('android');

export const isAndroidNative = (): boolean => (window?.native && isAndroid()) || false;

export const isMobile = (): boolean =>
    /iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(
        window?.navigator?.userAgent.toLowerCase()
    );

export const getAppTypeDetails = (): 'ios native' | 'android native' | 'web' => {
    if (isIOSNative()) {
        return 'ios native';
    }

    if (isAndroidNative()) {
        return 'android native';
    }

    return 'web';
};

export const getDevice = (): 'MOBILE' | 'DESKTOP' => {
    return isMobile() ? 'MOBILE' : 'DESKTOP';
};
// @ts-expect-error Legacy code with missing types
export const storeDeviceInfo = (cookies): void => {
    const deviceInfo = {
        device: getDevice(),
        fingerprint: '',
        deviceId: device.getDeviceId()
    };
    const appInfo = {
        type: getDevice().toLowerCase(),
        details: getAppTypeDetails()
    };
    cookies.set(COOKIES.KAZUMO, btoa(JSON.stringify({ deviceInfo, appInfo })), {
        path: '/',
        secure: 'true',
        sameSite: 'lax'
    });
};
